/**
 * Device Info Service
 * איסוף נתוני דפדפן, מערכת הפעלה ומכשיר
 */

export interface DeviceInfo {
  browserName: string;
  browserVersion: string;
  osName: string;
  osVersion: string;
  deviceType: 'desktop' | 'mobile' | 'tablet';
  userAgent: string;
}

/**
 * Parses user agent string to extract device information
 */
function parseUserAgent(): DeviceInfo {
  const userAgent = navigator.userAgent;
  
  // Browser detection
  let browserName = 'Unknown';
  let browserVersion = 'Unknown';
  
  if (userAgent.includes('Chrome') && !userAgent.includes('Edg')) {
    browserName = 'Chrome';
    const match = userAgent.match(/Chrome\/(\d+)/);
    browserVersion = match ? match[1] : 'Unknown';
  } else if (userAgent.includes('Firefox')) {
    browserName = 'Firefox';
    const match = userAgent.match(/Firefox\/(\d+)/);
    browserVersion = match ? match[1] : 'Unknown';
  } else if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
    browserName = 'Safari';
    const match = userAgent.match(/Version\/(\d+)/);
    browserVersion = match ? match[1] : 'Unknown';
  } else if (userAgent.includes('Edg')) {
    browserName = 'Edge';
    const match = userAgent.match(/Edg\/(\d+)/);
    browserVersion = match ? match[1] : 'Unknown';
  } else if (userAgent.includes('Opera') || userAgent.includes('OPR')) {
    browserName = 'Opera';
    const match = userAgent.match(/(?:Opera|OPR)\/(\d+)/);
    browserVersion = match ? match[1] : 'Unknown';
  }
  
  // OS detection
  let osName = 'Unknown';
  let osVersion = 'Unknown';
  
  if (userAgent.includes('Windows')) {
    osName = 'Windows';
    if (userAgent.includes('Windows NT 10.0')) osVersion = '10';
    else if (userAgent.includes('Windows NT 6.3')) osVersion = '8.1';
    else if (userAgent.includes('Windows NT 6.2')) osVersion = '8';
    else if (userAgent.includes('Windows NT 6.1')) osVersion = '7';
  } else if (userAgent.includes('Mac OS X') || userAgent.includes('Macintosh')) {
    osName = 'macOS';
    const match = userAgent.match(/Mac OS X (\d+[._]\d+)/);
    osVersion = match ? match[1].replace('_', '.') : 'Unknown';
  } else if (userAgent.includes('Linux')) {
    osName = 'Linux';
    osVersion = 'Unknown';
  } else if (userAgent.includes('Android')) {
    osName = 'Android';
    const match = userAgent.match(/Android (\d+\.?\d*)/);
    osVersion = match ? match[1] : 'Unknown';
  } else if (userAgent.includes('iPhone') || userAgent.includes('iPad')) {
    osName = userAgent.includes('iPad') ? 'iPadOS' : 'iOS';
    const match = userAgent.match(/OS (\d+[._]\d+)/);
    osVersion = match ? match[1].replace('_', '.') : 'Unknown';
  }
  
  // Device type detection
  let deviceType: 'desktop' | 'mobile' | 'tablet' = 'desktop';
  
  if (userAgent.includes('Mobile') || userAgent.includes('Android')) {
    if (userAgent.includes('iPad') || (userAgent.includes('Tablet') && !userAgent.includes('Mobile'))) {
      deviceType = 'tablet';
    } else {
      deviceType = 'mobile';
    }
  } else if (userAgent.includes('iPad')) {
    deviceType = 'tablet';
  }
  
  return {
    browserName,
    browserVersion,
    osName,
    osVersion,
    deviceType,
    userAgent,
  };
}

/**
 * Get current device information
 */
export function getDeviceInfo(): DeviceInfo {
  return parseUserAgent();
}

/**
 * Get device info as a formatted string (for logging)
 */
export function getDeviceInfoString(): string {
  const info = getDeviceInfo();
  return `${info.browserName} ${info.browserVersion} on ${info.osName} ${info.osVersion} (${info.deviceType})`;
}

